{
    "nav": {
        "dashboard": "طوابير الفروع",
        "appointments": "المواعيد",
        "hardware": "أجهزة الفروع",
        "configuration": "الخدمات والشبابيك",
        "simulator": "محاكي الفرع"
    },

    "pairing": {
        "title": "اقتران هذا الجهاز",
        "description": "أدخل الرمز المكوّن من ستة أحرف الظاهر في شاشة أجهزة الفروع.",
        "code": "رمز الاقتران",
        "submit": "اقتران الجهاز",
        "paired": "تم الاقتران مع {{branch}}.",
        "unpair": "إلغاء اقتران الجهاز",
        "unpair_confirm": "هل تريد إلغاء اقتران هذا الجهاز؟ سيتوقف عن عرض الطابور حتى يُقترن من جديد.",
        "invalid": "لم يُقبل هذا الرمز."
    },

    "kiosk": {
        "welcome": "أهلاً وسهلاً",
        "choose_service": "الرجاء اختيار الخدمة",
        "identify": "هل أنت من عملاء البنك؟",
        "identify_hint": "أدخل الرقم المدني لإضافة هذه الزيارة إلى سجلك. هذا اختياري.",
        "civil_id": "الرقم المدني",
        "skip": "المتابعة دون تعريف",
        "issue": "استخراج تذكرة",
        "issuing": "جارٍ إصدار تذكرتك…",
        "your_number": "رقمك",
        "now_serving_short": "يُخدم الآن",
        "people_waiting": "{{count}} في الانتظار",
        "people_waiting_one": "شخص واحد في الانتظار",
        "about_minutes": "حوالي {{count}} دقيقة",
        "over_minutes": "أكثر من {{count}} دقيقة",
        "not_serving": "غير متاحة الآن",
        "identified": "أُضيفت إلى سجلك",
        "print": "طباعة",
        "done": "تم",
        "another": "استخراج تذكرة أخرى",
        "closing_in": "تعود هذه الشاشة خلال {{count}} ثانية"
    },

    "display": {
        "now_serving": "يُخدم الآن",
        "counter": "الشباك",
        "next": "التالي",
        "waiting": "في الانتظار",
        "open_counters": "الشبابيك المفتوحة",
        "nothing_serving": "لا توجد أرقام قيد النداء",
        "recall": "إعادة النداء",
        "sound_on": "الصوت يعمل",
        "sound_off": "الصوت متوقف",
        "sound_hint": "تُنادى الأرقام بالعربية والإنجليزية."
    },

    "counter": {
        "title": "الشباك {{code}}",
        "open": "فتح الشباك",
        "pause": "إيقاف مؤقت",
        "close": "إغلاق الشباك",
        "pause_reason": "السبب (اختياري)",
        "call_next": "نداء التالي",
        "recall": "إعادة النداء",
        "start": "بدء الخدمة",
        "complete": "إنهاء",
        "no_show": "لم يحضر",
        "recycle": "إعادة إلى الطابور",
        "transfer": "تحويل إلى…",
        "current": "على الشباك",
        "nobody": "لا يوجد أحد على الشباك",
        "queue": "المنتظرون في هذا الفرع",
        "not_servable": "شباك آخر",
        "served_today": "خُدموا اليوم",
        "mean_service": "متوسط زمن الخدمة",
        "no_shows": "لم يحضروا",
        "waiting_for": "منتظر منذ {{time}}",
        "attempts": "نُودي {{count}} مرات",
        "closed_notice": "هذا الشباك مغلق. افتحه لبدء نداء العملاء.",
        "paused_notice": "هذا الشباك متوقف مؤقتاً، ولا يُحتسب في تقدير مدة الانتظار.",
        "vip": "عميل مميز",
        "assistance": "يحتاج مساعدة",
        "view_customer": "فتح سجل العميل"
    },

    "dashboard": {
        "title": "طوابير الفروع",
        "subtitle": "مباشر على مستوى الشبكة",
        "waiting": "في الانتظار الآن",
        "serving": "قيد الخدمة",
        "completed": "خُدموا اليوم",
        "alerting": "فروع تحتاج متابعة",
        "branch": "الفرع",
        "open_counters": "مفتوحة",
        "longest_wait": "أطول انتظار",
        "mean_wait": "متوسط الانتظار",
        "target": "المستهدف",
        "met_target": "ضمن المستهدف",
        "no_shows": "لم يحضروا",
        "alert": "الحالة",
        "map": "الشبكة",
        "forecast": "الطلب المتوقع",
        "forecast_for": "الطلب المتوقع في {{branch}}",
        "hour": "الساعة",
        "expected": "العملاء المتوقعون",
        "suggested": "الشبابيك المقترحة",
        "no_forecast": "لا يوجد سجل كافٍ لهذا الفرع بعد.",
        "alerts": {
            "ok": "ضمن المستهدف",
            "warning": "تجاوز المستهدف",
            "critical": "تجاوز كبير للمستهدف",
            "closed": "مغلق",
            "closed_with_queue": "مغلق ويوجد منتظرون"
        }
    },

    "appointments": {
        "title": "المواعيد",
        "reference": "الرقم المرجعي",
        "when": "الموعد",
        "customer": "العميل",
        "contact": "وسيلة التواصل",
        "service": "الخدمة",
        "branch": "الفرع",
        "status": "الحالة",
        "confirm": "تأكيد",
        "reschedule": "تغيير الموعد",
        "cancel": "إلغاء",
        "check_in": "تسجيل الحضور",
        "reschedule_title": "نقل هذا الموعد",
        "reschedule_to": "التاريخ والوقت الجديد",
        "cancel_title": "إلغاء هذا الموعد",
        "cancel_reason": "السبب",
        "empty": "لا توجد مواعيد مطابقة لهذه المرشّحات.",
        "walk_in": "ليس عميلاً مسجلاً",
        "statuses": {
            "booked": "محجوز",
            "confirmed": "مؤكد",
            "checked_in": "تم الحضور",
            "completed": "منتهٍ",
            "cancelled": "ملغى",
            "no_show": "لم يحضر"
        }
    },

    "hardware": {
        "title": "أجهزة الفروع",
        "device": "الجهاز",
        "branch": "الفرع",
        "type": "النوع",
        "serial": "الرقم التسلسلي",
        "version": "إصدار التطبيق",
        "battery": "البطارية",
        "last_seen": "آخر ظهور",
        "state": "الحالة",
        "warranty": "الضمان",
        "online": "متصل",
        "offline": "غير متصل",
        "unpaired": "غير مقترن",
        "pair": "إصدار رمز اقتران",
        "refresh": "إعادة تحميل الجهاز",
        "pairing_code_is": "رمز الاقتران: {{code}}",
        "pairing_code_hint": "أدخل هذا الرمز في الجهاز. يعمل مرة واحدة.",
        "warranty_expired": "منتهٍ",
        "never_seen": "لم يظهر بعد",
        "empty": "لا توجد أجهزة مسجلة.",
        "types": {
            "kiosk": "جهاز إصدار التذاكر",
            "display": "شاشة الصالة",
            "counter": "طرفية الشباك",
            "printer": "طابعة"
        }
    },

    "configuration": {
        "title": "الخدمات والشبابيك",
        "services": "الخدمات",
        "counters": "الشبابيك",
        "code": "الرمز",
        "name": "الاسم",
        "prefix": "حرف التذكرة",
        "default_minutes": "الدقائق المتوقعة",
        "remote": "الطابور عن بُعد",
        "appointment": "المواعيد",
        "active": "مفعّلة",
        "serves": "يخدم",
        "serves_all": "كل الخدمات",
        "priority_only": "للأولوية فقط",
        "status": "الحالة",
        "save": "حفظ الشباك",
        "edit": "تعديل",
        "new_counter": "إضافة شباك",
        "counter_code": "رمز الشباك",
        "name_en": "الاسم (بالإنجليزية)",
        "name_ar": "الاسم (بالعربية)",
        "statuses": {
            "open": "مفتوح",
            "paused": "متوقف مؤقتاً",
            "closed": "مغلق"
        }
    },

    "join": {
        "title": "احجز دورك قبل أن تنطلق",
        "subtitle": "خذ مكانك في الطابور من المنزل واحضر عندما يقترب دورك.",
        "branch": "الفرع",
        "service": "الخدمة",
        "phone": "رقم الهاتف",
        "name": "الاسم (اختياري)",
        "submit": "الانضمام إلى الطابور",
        "check": "متابعة دوري",
        "number": "رقم التذكرة",
        "position": "ترتيبك {{position}} في الطابور",
        "estimated": "حوالي {{count}} دقيقة",
        "unknown_wait": "الفرع لا يقدم هذه الخدمة الآن",
        "cancel": "التخلي عن دوري",
        "cancel_confirm": "هل تريد التخلي عن دورك في الطابور؟",
        "cancelled": "تم التخلي عن دورك.",
        "called": "نُودي رقمك — الرجاء التوجه إلى {{counter}}.",
        "not_found": "لا توجد تذكرة تطابق هذا الرقم ورقم الهاتف لليوم.",
        "choose_branch": "اختر الفرع",
        "choose_service": "اختر الخدمة",
        "have_ticket": "لديّ تذكرة بالفعل",
        "back_to_join": "الانضمام إلى طابور بدلاً من ذلك"
    },

    "simulator": {
        "title": "محاكي الفرع",
        "description": "يشغّل طابور الفرع حتى يمكن عرض الشاشة وجهاز التذاكر ولوحة المتابعة دون وجود أحد على الشباك.",
        "branch": "الفرع",
        "arrivals": "عدد العملاء المضافين",
        "run": "تشغيل",
        "running": "جارٍ التشغيل…",
        "step": "خدمة عميل واحد",
        "clear": "مسح طابور اليوم",
        "cleared": "تم مسح طابور اليوم في هذا الفرع.",
        "added": "أُضيف {{count}} عميلاً إلى الطابور.",
        "served": "تمت خدمة {{number}}.",
        "nothing": "لا يوجد أحد في الانتظار.",
        "warning": "يكتب هذا تذاكر حقيقية في الفرع المحدد."
    },

    "priority": {
        "0": "عادي",
        "1": "موعد",
        "2": "عميل مميز",
        "3": "كبار السن",
        "4": "يحتاج مساعدة",
        "5": "حامل"
    },

    "status": {
        "waiting": "في الانتظار",
        "called": "تم النداء",
        "serving": "قيد الخدمة",
        "completed": "منتهٍ",
        "no_show": "لم يحضر",
        "cancelled": "ملغاة",
        "transferred": "محوّلة"
    }
}
